<template>
  <div class="cookie-banner-container" v-if="shouldShow">
    <span>
      We use cookies to ensure that we give you the best experience on our website.
      Click <router-link to="/cookies" target="_blank">here</router-link> for more information.
    </span>
    <button aria-label="Got It" @click="setAccepted">Agree</button>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      cookieName: 'acceptYp',
      justAccepted: false,
      maxAgeInSeconds: 60 * 60 * 24 * 365, // 1 year
    };
  },
  computed: {
    hadAcceptedInThePast() {
      return document.cookie
        .split(';')
        .filter(item => item.trim().startsWith(`${this.cookieName}=`))
        .length > 0;
    },
    shouldShow() {
      if (this.hadAcceptedInThePast || this.justAccepted) {
        return false;
      }
      return true;
    },
  },
  methods: {
    setAccepted() {
      document.cookie = `${this.cookieName}=true; max-age=${this.maxAgeInSeconds}`;
      this.justAccepted = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-banner-container {
  position: fixed;
  z-index: 10;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.cookie-banner-container a {
  color: white;
}

.cookie-banner-container button {
  min-width: 5rem;
  margin-left: 2rem;
  padding: 0 1rem;
  height: 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  color: white;
  cursor: pointer;
  background: rgba(0, 0, 0, 1);
  border-color: black;
}
</style>
